import { render, staticRenderFns } from "./FormUserPerfil.vue?vue&type=template&id=b7847f9a&scoped=true"
import script from "./FormUserPerfil.vue?vue&type=script&lang=js"
export * from "./FormUserPerfil.vue?vue&type=script&lang=js"
import style0 from "./FormUserPerfil.vue?vue&type=style&index=0&id=b7847f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7847f9a",
  null
  
)

export default component.exports